import {
  utils,
} from '@ama-sdk/core';
import {
  DisruptionEvent,
  DisruptionStatus,
} from '@dapi/sdk';
import {
  createDisruptionStatus,
} from '@dapi/sdk/spec';
import {
  cphLhrFlightAI,
  cphOslFlightItem,
  cphOslOriginalFlightItem,
  cphOslUnOnlyFlightItem,
  cphOslUnOnlyFlightItemFixedDate,
  helTkuFlightItem,
  helTkuOriginalFlightItem,
  lhrOslFlight,
  oslCphFlightItem,
  oslCphOriginalFlightItem,
  oslCphUnOnlyFlightItem,
  oslCphUnOnlyFlightItemDifferentFlightId,
  oslLhrFlightItem,
  tkuHelFlightItem,
  tkuHelOriginalFlightItem,
} from './flights';

const disruptionEvent: DisruptionEvent = {
  triggerEventName: 'Travel Ready Re-accommodation',
  dateTime: new utils.DateTime('2023-06-20T08:48:59.000Z')
};

export const cphOslDisruptionStatus: DisruptionStatus = createDisruptionStatus({
  template: {
    connection: {
      delta: 0,
      sameViaPoint: true,
      deltaTime: 0,
      status: 'ok'
    },
    boundStatus: 'disrupted',
    originalFlights: [{
      ...cphOslUnOnlyFlightItem,
      bookingStatus: {
        name: 'Does not operate'
      }
    }],
    departure: {
      locationCode: 'CPH',
      deltaTime: 18_900
    },
    arrival: {
      locationCode: 'OSL',
      deltaTime: 18_900
    },
    disruptionEvents: [disruptionEvent],
    duration: 4200
  }
});

export const cphLhrOslDisruptionStatus: DisruptionStatus = createDisruptionStatus({
  template: {
    connection: {
      delta: 0,
      sameViaPoint: true,
      deltaTime: 0,
      status: 'ok'
    },
    boundStatus: 'disrupted',
    originalFlights: [cphOslUnOnlyFlightItem, oslLhrFlightItem],
    departure: {
      locationCode: 'CPH',
      deltaTime: 18_900
    },
    arrival: {
      locationCode: 'OSL',
      deltaTime: 18_900
    },
    disruptionEvents: [disruptionEvent],
    duration: 4200
  }
});

export const oslLhrDisruptionStatus: DisruptionStatus = createDisruptionStatus({
  template: {
    connection: {
      delta: 0,
      sameViaPoint: true,
      deltaTime: 0,
      status: 'ok'
    },
    boundStatus: 'disrupted',
    originalFlights: [{
      ...oslCphUnOnlyFlightItem,
      bookingStatus: {
        name: 'Does not operate'
      }
    }],
    departure: {
      locationCode: 'OSL',
      deltaTime: 18_900
    },
    arrival: {
      locationCode: 'LHR',
      deltaTime: 18_900
    },
    disruptionEvents: [disruptionEvent],
    duration: 4200
  }
});

export const cphOslAcknowledgeDisruptionStatus: DisruptionStatus = createDisruptionStatus({
  template: {
    connection: {
      delta: 0,
      sameViaPoint: true,
      deltaTime: 0,
      status: 'ok'
    },
    boundStatus: 'acknowledged',
    originalFlights: [{
      ...cphOslFlightItem,
      statusCode: undefined
    }],
    departure: {
      locationCode: 'CPH',
      deltaTime: 18_900
    },
    arrival: {
      locationCode: 'OSL',
      deltaTime: 18_900
    },
    disruptionEvents: [disruptionEvent],
    duration: 4200
  }
});

export const cphOslScheduleChangeStatus: DisruptionStatus = createDisruptionStatus({
  template: {
    arrival: {
      locationCode: 'OSL',
      deltaTime: 18_900
    },
    boundStatus: 'disrupted',
    connection: {
      delta: 0,
      sameViaPoint: true,
      deltaTime: 0,
      status: 'ok'
    },
    departure: {
      locationCode: 'CPH',
      deltaTime: 18_900
    },
    disruptionEvents: [disruptionEvent],
    originalFlights: [{
      ...cphOslOriginalFlightItem,
      flight: cphLhrFlightAI
    }, {
      ...cphOslOriginalFlightItem,
      flight: lhrOslFlight,
      statusCode: 'HK'
    }],
    duration: 4800
  }
});

export const oslCphScheduleChangeStatus: DisruptionStatus = createDisruptionStatus({
  template: {
    arrival: {
      locationCode: 'CPH',
      deltaTime: 18_900
    },
    boundStatus: 'disrupted',
    connection: {
      delta: 0,
      sameViaPoint: true,
      deltaTime: 0,
      status: 'ok'
    },
    departure: {
      locationCode: 'OSL',
      deltaTime: 18_900
    },
    disruptionEvents: [disruptionEvent],
    originalFlights: [oslCphOriginalFlightItem],
    duration: 4200
  }
});

export const oslCphAcknowledgeDisruptionStatus: DisruptionStatus = createDisruptionStatus({
  template: {
    connection: {
      delta: 0,
      sameViaPoint: true,
      deltaTime: 0,
      status: 'ok'
    },
    boundStatus: 'acknowledged',
    originalFlights: [{
      ...oslCphFlightItem,
      statusCode: undefined
    }],
    departure: {
      locationCode: 'OSL',
      deltaTime: 18_900
    },
    arrival: {
      locationCode: 'CPH',
      deltaTime: 18_900
    },
    disruptionEvents: [disruptionEvent],
    duration: 4200
  }
});

export const helTkuAcknowledgeDisruptionStatus: DisruptionStatus = createDisruptionStatus({
  template: {
    connection: {
      delta: 0,
      sameViaPoint: true,
      deltaTime: 0,
      status: 'ok'
    },
    boundStatus: 'acknowledged',
    originalFlights: [{
      ...helTkuFlightItem,
      statusCode: undefined
    }],
    departure: {
      locationCode: 'HEL',
      deltaTime: 18_900
    },
    arrival: {
      locationCode: 'TKU',
      deltaTime: 18_900
    },
    disruptionEvents: [disruptionEvent],
    duration: 4200
  }
});

export const tkuHelAcknowledgeDisruptionStatus: DisruptionStatus = createDisruptionStatus({
  template: {
    connection: {
      delta: 0,
      sameViaPoint: true,
      deltaTime: 0,
      status: 'ok'
    },
    boundStatus: 'acknowledged',
    originalFlights: [{
      ...tkuHelFlightItem,
      statusCode: undefined
    }],
    departure: {
      locationCode: 'TKU',
      deltaTime: 18_900
    },
    arrival: {
      locationCode: 'HEL',
      deltaTime: 18_900
    },
    disruptionEvents: [disruptionEvent],
    duration: 4200
  }
});

export const oslCphDisruptionStatus: DisruptionStatus = createDisruptionStatus({
  template: {
    connection: {
      delta: 0,
      sameViaPoint: true,
      deltaTime: 0,
      status: 'ok'
    },
    boundStatus: 'disrupted',
    originalFlights: [{
      ...oslCphUnOnlyFlightItem,
      bookingStatus: {
        name: 'Does not operate'
      }
    }],
    departure: {
      locationCode: 'OSL',
      deltaTime: 18_900
    },
    arrival: {
      locationCode: 'CPH',
      deltaTime: 18_900
    },
    disruptionEvents: [disruptionEvent],
    duration: 4200
  }
});

export const oslCphDisruptionStatusWithDifferentFlightId: DisruptionStatus = createDisruptionStatus({
  template: {
    connection: {
      delta: 0,
      sameViaPoint: true,
      deltaTime: 0,
      status: 'ok'
    },
    boundStatus: 'disrupted',
    originalFlights: [{
      ...oslCphUnOnlyFlightItemDifferentFlightId,
      bookingStatus: {
        name: 'Does not operate'
      }
    }],
    departure: {
      locationCode: 'OSL',
      deltaTime: 18_900
    },
    arrival: {
      locationCode: 'CPH',
      deltaTime: 18_900
    },
    disruptionEvents: [disruptionEvent],
    duration: 4200
  }
});

export const oslCphDisruptionStatusWithCityChange: DisruptionStatus = createDisruptionStatus({
  template: {
    connection: {
      delta: 0,
      sameViaPoint: true,
      deltaTime: 0,
      status: 'ok'
    },
    boundStatus: 'disrupted',
    originalFlights: [{
      ...oslCphUnOnlyFlightItemDifferentFlightId,
      bookingStatus: {
        name: 'Does not operate'
      }
    }],
    departure: {
      locationCode: 'OSL',
      deltaTime: 10_200,
      sameAirport: true,
      sameCity: true,
      sameDay: true
    },
    arrival: {
      locationCode: 'CPH',
      deltaTime: 7500,
      sameAirport: false,
      sameCity: false,
      sameDay: true
    },
    disruptionEvents: [disruptionEvent],
    duration: 4200,
    isInCheckInTimeWindow: false
  }
});

export const oslCphAcknowledgedStatusWithCityChange: DisruptionStatus = createDisruptionStatus({
  template: {
    connection: {
      delta: 0,
      sameViaPoint: true,
      deltaTime: 0,
      status: 'ok'
    },
    boundStatus: 'acknowledged',
    originalFlights: [{
      ...oslCphUnOnlyFlightItemDifferentFlightId,
      bookingStatus: {
        name: 'Does not operate'
      }
    }],
    departure: {
      locationCode: 'OSL',
      deltaTime: 10_200,
      sameAirport: true,
      sameCity: true,
      sameDay: true
    },
    arrival: {
      locationCode: 'CPH',
      deltaTime: 7500,
      sameAirport: false,
      sameCity: false,
      sameDay: true
    },
    disruptionEvents: [disruptionEvent],
    duration: 4200,
    isInCheckInTimeWindow: false
  }
});

export const unOnlyDisruptionStatus: DisruptionStatus = createDisruptionStatus({
  template: {
    boundStatus: 'disrupted',
    originalFlights: [cphOslUnOnlyFlightItem],
    arrival: {
      locationCode: 'OSL'
    },
    departure: {
      locationCode: 'CPH'
    },
    disruptionEvents: [disruptionEvent],
    duration: 4200
  }
});

export const unOnlyDisruptionStatusFixedDate: DisruptionStatus = createDisruptionStatus({
  template: {
    boundStatus: 'disrupted',
    originalFlights: [cphOslUnOnlyFlightItemFixedDate],
    arrival: {
      locationCode: 'OSL'
    },
    departure: {
      locationCode: 'CPH'
    },
    disruptionEvents: [disruptionEvent],
    duration: 4200
  }
});

export const unOnlyReturnFlightDisruptionStatus: DisruptionStatus = createDisruptionStatus({
  template: {
    boundStatus: 'disrupted',
    originalFlights: [oslCphUnOnlyFlightItem],
    arrival: {
      locationCode: 'CPH'
    },
    departure: {
      locationCode: 'OSL'
    },
    disruptionEvents: [disruptionEvent],
    duration: 4200
  }
});

export const helTkuDisruptionStatus: DisruptionStatus = createDisruptionStatus({
  template: {
    connection: {
      status: 'ok',
      delta: 0,
      sameViaPoint: true,
      deltaTime: 0
    },
    originalFlights: [helTkuOriginalFlightItem],
    boundStatus: 'disrupted',
    arrival: {
      locationCode: 'TKU',
      deltaTime: 8400,
      sameAirport: true,
      sameCity: true,
      sameDay: true
    },
    departure: {
      locationCode: 'HEL',
      deltaTime: 8400,
      sameAirport: true,
      sameCity: true,
      sameDay: true
    },
    duration: 2100
  }
});

export const tkuHelDisruptionStatus: DisruptionStatus = createDisruptionStatus({
  template: {
    boundStatus: 'disrupted',
    originalFlights: [tkuHelOriginalFlightItem],
    connection: {
      status: 'ok',
      delta: 0,
      sameViaPoint: true,
      deltaTime: 0
    },
    arrival: {
      locationCode: 'HEL',
      deltaTime: 8400,
      sameAirport: true,
      sameCity: true,
      sameDay: true
    },
    departure: {
      locationCode: 'TKU',
      deltaTime: 8400,
      sameAirport: true,
      sameCity: true,
      sameDay: true
    },
    duration: 2100
  }
});
